<template>
  <div class="ele-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          :measureId="queryMeasureId"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
          @changeCompany="changeCompany"
        ></tab-tree>
      </div>
      <div class="content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="search-box box">
          <time-search
            ref="timeSearch"
            :control="{ data: !isStatistic ? timeData.slice(0, 2) : timeData }"
            @timeControlChange="timeControlChange"
            @timeControlClick="TimeControlClick"
            @timeChange="timeChange"
          >
            <div class="time-search-slot">
              <el-select
                style="width: 120px; margin-left: 10px"
                v-show="
                  (selectedDate.dateType == 'day' ||
                    selectedDate.dateType == 'timeInterval') &&
                    !isStatistic
                "
                v-model="searchType"
              >
                <el-option label="按小时间隔" value="hour"></el-option>
                <el-option label="按采集间隔" value="measuring"></el-option>
              </el-select>
            </div>
          </time-search>
        </div>
        <div class="grid-content item-box">
          <div class="details-content">
            <div class="item-box box">
              <measure-info
                :measureId="analysisChartObj.measureId"
              ></measure-info>
            </div>
            <div class="item-box tab-box box itemScol">
              <el-radio-group
                size="small"
                v-model="selectedTab"
                @change="tabChange"
              >
                <el-radio-button
                  v-for="(item, index) in tabList"
                  :key="index"
                  :label="item.name"
                  >{{ item.displayName }}</el-radio-button
                >
              </el-radio-group>
            </div>
            <div class="item-box chart-box box">
              <div class="btn-circular" @click="bindPrev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="btn-circular btn-circular-right" @click="bindNext">
                <i class="el-icon-arrow-right"></i>
              </div>
              <analysis-chart
                :isStatistic="isStatistic"
                ref="analysisChart"
                :forwardFlowUnit="forwardFlowUnit"
                :selectedTab="selectedTab"
                :measureName="selectedMeasure.measureName"
                v-if="showAnalysisChart"
              ></analysis-chart>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import TabTree from "@/components/common/TabTree.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import MeasureInfo from "@/components/page/ele/MeasureInfo.vue";
import AnalysisChart from "./analysisChart";
import TimeSearch from "@/components/common/TimeSearch.vue";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import tmp from "./tmp";
import dateTool from "@/utils/dateTool";

let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
let eleTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  name: "ele",
  // 引用组件
  components: {
    TabTree,
    BtnShow,
    MeasureInfo,
    AnalysisChart,
    TimeSearch,
    ResizeContainer,
  },
  data() {
    return {
      isStatistic: false,
      ishowbtn: false,
      pageParamTabData: [],
      timerRange: "",
      tabList: [],
      timeData: allTimeData,
      tabData: [],
      searchType: "hour",
      tabShow: true,
      viewTreeData: [],
      selectedTab: "",
      selectedMeasure: {
        measureId: "",
        measureName: "",
      },
      selectedDate: {
        startTime: "",
        endTime: "",
      },
      showSearchType: false,
      analysisChartObj: {
        measureId: "",
        measureName: "",
        startTime: "",
        tabType: "",
        endTime: "",
        searchType: "",
      },
      listVal: "",
      showHomocycleRatio: false,
      //运行状态
      runningState: null,
      showAnalysisChart: true,
      queryMeasureId: "",
      forwardFlowUnit: "",
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate() {},
  // 实例已经创建完成之后被调用。
  created() {},
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {},
  // keep-alive组件激活时调用
  activated() {
    let vm = this;
    //vm.$route.query
    let query = vm.$route.query;
    if (query.measureId) {
      vm.queryMeasureId = query.measureId;
    }
    if (query.code) {
      const item = window.baseConfig.collectData.find(
        (c) => c.code == query.code
      );
      if (item) {
        vm.selectedTab = item.tabName;
      }
    }

    // this.$refs.analysisChart.setChartResize();
  },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated() {},
  //当前路由改变
  beforeRouteUpdate() {},
  // Vue 实例销毁后调用
  destroyed() {},
  // 计算属性
  computed: {},
  // 方法定义
  methods: {
    timeChange(e) {
      console.log(e);
      this.timerRange = e;
    },
    changeCompany(companyId) {
      this.init(companyId);
    },
    init(companyId) {
      let vm = this;
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(
          companyId,
          "/analysis/operationalAnalysis/index7",
          null
        )
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          const tabData = findDataByParam("tabData", true, res.data);
          vm.viewTreeData = viewTreeData;
          vm.pageParamTabData = tabData;
        });
    },
    timeControlChange(e) {
      this.selectedDate = e;
      console.log(e);
      this.analysisChartObj.timeType = e.dateType;
      this.analysisChartObj.startTime = e.startTime;
      this.analysisChartObj.endTime = e.endTime;
      this.isShowSearchType(this.selectedTab, e.dateType);
    },
    TimeControlClick(e) {
      let vm = this;
      vm.selectedDate = e;
      this.analysisChartObj.timeType = e.dateType;
      this.analysisChartObj.startTime = e.startTime;
      this.analysisChartObj.endTime = e.endTime;
      vm.getRunningAnalyseChartData();
    },

    getRunningAnalyseChartData() {
      let vm = this;
      let timeType = "hour";
      let pattern = "hh时";
      let xData = [];
      switch (vm.analysisChartObj.timeType) {
        case "day":
          timeType = "hour";

          break;
        case "week":
          timeType = "day";
          pattern = "dd日";
          break;
        case "month":
          timeType = "day";
          pattern = "MM月dd日";
          break;
        case "year":
          timeType = "day";
          pattern = "MM月dd日";
          break;
        case "timeInterval":
          timeType = "day";
          pattern = "dd日hh时";
          break;
      }
      if (vm.analysisChartObj.timeType === "month" && !vm.isStatistic) {
        timeType = "hour";
        pattern = "hh时";
      }
      let type = 1;
      if (vm.searchType == "measuring") {
        type = 2;
        pattern = null;
      } else {
        xData = dateTool.createXDataForTime(
          timeType,
          vm.analysisChartObj.startTime,
          vm.analysisChartObj.endTime
        );
      }
      const tabItem = vm.tabList.find((c) => c.name === vm.selectedTab);
      if (!tabItem) {
        return;
      }
      tmp
        .getRunningAnalyseChartData(
          vm.selectedMeasure.measureId,
          tabItem.expData,
          type,
          timeType,
          vm.analysisChartObj.startTime,
          vm.analysisChartObj.endTime
        )
        .then((res) => {
          vm.$refs.analysisChart.getData(
            res.data,
            res.thisVal,
            tabItem,
            pattern,
            xData
          );
        });
    },
    tabTreeDefault(e) {
      let vm = this;
      this.selectedMeasure = e;
      vm.getRunningAnalyseTabData();
    },
    tabChange(e) {
      let vm = this;
      const item = vm.tabList.find((c) => c.name === e);
      vm.isStatistic = item.isStatistic;

      if (!vm.isStatistic && vm.selectedDate.dateType == "year") {
        vm.$refs.timeSearch.position = "day";
      }

      // 没有采集间隔得重置掉
      if (
        (vm.selectedDate.dateType == "day" ||
          vm.selectedDate.dateType == "timeInterval") &&
        !vm.isStatistic
      ) {
      } else {
        vm.searchType = "hour";
      }
      this.$nextTick(() => {
        vm.getRunningAnalyseChartData();
      });
    },
    getRunningAnalyseTabData() {
      let vm = this;
      tmp
        .getRunningAnalyseTabData(
          vm.selectedMeasure.measureId,
          vm.pageParamTabData
        )
        .then((res) => {
          this.tabList = res.data;
          if (this.tabList.length > 0) {
            const item = this.tabList.find((c) => c.name == this.selectedTab);
            vm.selectedTab = item ? item.name : res.data[0].name;
            vm.isStatistic = item ? item.isStatistic : res.data[0].isStatistic;
            vm.getRunningAnalyseChartData();
          }
        });
    },

    tabTreeClick(e) {
      let vm = this;
      vm.selectedMeasure = e;
      vm.analysisChartObj.measureId = e.measureId;
      vm.getRunningAnalyseTabData();
    },
    bindPrev() {
      this.$refs.timeSearch.prev();
    },
    bindNext() {
      this.$refs.timeSearch.next();
    },
    //获取底下图表数据
    getAnalysisChartData(e) {
      let vm = this;
      vm.analysisChartObj.timeType = vm.selectedDate.dateType;
      vm.analysisChartObj.searchType = vm.searchType;
      vm.analysisChartObj.startTime = vm.selectedDate.startTime;
      vm.analysisChartObj.endTime = vm.selectedDate.endTime;
      vm.analysisChartObj.measureId = vm.selectedMeasure.measureId;
      vm.analysisChartObj.measureName = vm.selectedMeasure.measureName;
      vm.analysisChartObj.tabType = vm.selectedTab;
      // vm.$refs.analysisChart.getData(vm.analysisChartObj);
    },
    /**
     * 是否显示采集间隔下拉框
     */
    isShowSearchType(selectedTab, dateType) {
      let vm = this;
      //只有查采集的接口才会有采集间隔
      const apiType = handleData.getTabTypeForApi(selectedTab);
      if (
        apiType === "measuring" &&
        (dateType === "day" || dateType === "timeInterval")
      ) {
        vm.showSearchType = true;
      } else {
        vm.searchType = "hour";
        vm.showSearchType = false;
      }
    },
  },
};
</script>
<style lang="scss">
.time-search-slot {
  .el-input__inner,
  .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
}
</style>
<style lang="scss" scoped>
.ele-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}
.tree-content {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  margin-right: 14px;
}
.content {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}
.grid-content {
  position: relative;
}
.details-content {
  width: 100%;
}
.table-content {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.table-layout {
  width: calc(100% + 20px);
  height: 340px;
  margin: -10px -10px -10px -10px;
}
.table-layout td {
  width: 25%;
}
.table-layout tr {
  height: 100%;
}
.item-box {
  width: 100%;
  text-align: left;
  margin-top: 14px;
}
.tab-box {
  // height: 32px;
}
.chart-box {
  position: relative;
  background: none;
}
.btn-circular {
  position: absolute;
  top: 150px;
  width: 50px;
  height: 50px;
  font-size: 30px;
  line-height: 50px;
  text-align: center;
  border-radius: 25px;
  color: #a7a7a7;
  z-index: 99;
}
.btn-circular:hover {
  background: #00000030;
  color: #ffffff;
  cursor: pointer;
}
.btn-circular-right {
  right: 0px;
}
.search-box {
  height: 36px;
}
.table-box {
  // padding-bottom: 20px;
}
.homocycle-ratio-box {
  width: 100%;
  height: 120px;
  padding: 10px;
  box-sizing: border-box;
}
.itemScol {
  overflow-x: auto;
  padding-bottom: 10px;
}
</style>
